var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.contract.CustomerType == _vm.CustomerTypeEnum.CONSUMER ||
      _vm.contract.CustomerType == _vm.CustomerTypeEnum.NOTSET
        ? _c(
            "div",
            [
              _c(
                "validated-form-group",
                {
                  attrs: {
                    "validation-id": "HousingType",
                    "validation-errors": _vm.validationErrors
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "basic-info" },
                    [
                      _c("b-form-group", {
                        staticClass: "mb-0",
                        attrs: {
                          "label-cols-sm": "12",
                          "label-cols-md": "12",
                          "label-cols-lg": "12"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { staticClass: "font-weight-bold pt-0" }, [
                        _vm._v(_vm._s(_vm.$t("Asumismuoto")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "contract-button-group" },
                        [
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "new-contract-value",
                                  rawName: "v-new-contract-value"
                                }
                              ],
                              staticClass: "btn-profile",
                              class: {
                                active:
                                  _vm.housingType ==
                                  _vm.HousingTypeEnum.APARTMENTHOUSE
                              },
                              attrs: {
                                disabled: _vm.loadingIndicator,
                                value: _vm.HousingTypeEnum.APARTMENTHOUSE,
                                variant: "outline-default",
                                name: "housingType"
                              },
                              on: { click: _vm.handleApartmentHouse }
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c("b-img", {
                                    staticClass: "img-process",
                                    attrs: {
                                      src: "/Content/PKS/images/kerrostalo.png",
                                      alt: "Asumismuoto kerrostalo"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "title",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.housingTypeString(
                                      _vm.HousingTypeEnum.APARTMENTHOUSE
                                    )
                                  )
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "new-contract-value",
                                  rawName: "v-new-contract-value"
                                }
                              ],
                              staticClass: "btn-profile",
                              class: {
                                active:
                                  _vm.housingType ==
                                  _vm.HousingTypeEnum.TERRACEDORDOUBLEHOUSE
                              },
                              attrs: {
                                disabled: _vm.loadingIndicator,
                                value:
                                  _vm.HousingTypeEnum.TERRACEDORDOUBLEHOUSE,
                                variant: "outline-default",
                                name: "housingType"
                              },
                              on: { click: _vm.handleTerracedOrDoubleHouse }
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c("b-img", {
                                    staticClass: "img-process",
                                    attrs: {
                                      src:
                                        "/Content/PKS/images/rivi-paritalo.png",
                                      alt: "Asumismuoto rivi/paritalo"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "title",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.housingTypeString(
                                      _vm.HousingTypeEnum.TERRACEDORDOUBLEHOUSE
                                    )
                                  )
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "new-contract-value",
                                  rawName: "v-new-contract-value"
                                }
                              ],
                              staticClass: "btn-profile",
                              class: {
                                active:
                                  _vm.housingType == _vm.HousingTypeEnum.HOUSE
                              },
                              attrs: {
                                disabled: _vm.loadingIndicator,
                                value: _vm.HousingTypeEnum.HOUSE,
                                variant: "outline-default",
                                name: "housingType"
                              },
                              on: { click: _vm.handleHouse }
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c("b-img", {
                                    staticClass: "img-process",
                                    attrs: {
                                      src:
                                        "/Content/PKS/images/omakotitalo.png",
                                      alt: "Asumismuoto omakotitalo"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "title",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.housingTypeString(
                                      _vm.HousingTypeEnum.HOUSE
                                    )
                                  )
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "new-contract-value",
                                  rawName: "v-new-contract-value"
                                }
                              ],
                              staticClass: "btn-profile",
                              class: {
                                active:
                                  _vm.housingType == _vm.HousingTypeEnum.COTTAGE
                              },
                              attrs: {
                                disabled: _vm.loadingIndicator,
                                value: _vm.HousingTypeEnum.COTTAGE,
                                variant: "outline-default",
                                name: "housingType"
                              },
                              on: { click: _vm.handleCottage }
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c("b-img", {
                                    staticClass: "img-process",
                                    attrs: {
                                      src: "/Content/PKS/images/mokki.png",
                                      alt: "Asumismuoto mökki"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "title",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.housingTypeString(
                                      _vm.HousingTypeEnum.COTTAGE
                                    )
                                  )
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "new-contract-value",
                                  rawName: "v-new-contract-value"
                                }
                              ],
                              staticClass: "btn-profile",
                              class: {
                                active:
                                  _vm.housingType == _vm.HousingTypeEnum.OTHER
                              },
                              attrs: {
                                disabled: _vm.loadingIndicator,
                                value: _vm.HousingTypeEnum.OTHER,
                                variant: "outline-default",
                                name: "housingType"
                              },
                              on: { click: _vm.handleOtherConsumer }
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c("b-img", {
                                    staticClass: "img-process",
                                    attrs: {
                                      src:
                                        "/Content/PKS/images/asumismuoto_muu.png",
                                      alt: "Muu asumismuoto"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "title",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.housingTypeString(
                                      _vm.HousingTypeEnum.OTHER
                                    )
                                  )
                                }
                              })
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "heatingType" } },
        [
          _c(
            "validated-form-group",
            {
              attrs: {
                "validation-id": "HeatingType",
                "validation-errors": _vm.validationErrors
              }
            },
            [
              _c(
                "div",
                { staticClass: "basic-info" },
                [
                  _c("b-form-group", {
                    staticClass: "mb-0",
                    attrs: {
                      "label-cols-sm": "12",
                      "label-cols-md": "12",
                      "label-cols-lg": "12"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { staticClass: "font-weight-bold pt-0" }, [
                    _vm._v(_vm._s(_vm.$t("Pääasiallinen lämmitystapa")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "contract-button-group" },
                    [
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "new-contract-value",
                              rawName: "v-new-contract-value"
                            }
                          ],
                          staticClass: "btn-profile",
                          class: {
                            active:
                              _vm.heatingType == _vm.HeatingTypeEnum.ELECTRICITY
                          },
                          attrs: {
                            disabled: _vm.loadingIndicator,
                            value: _vm.HeatingTypeEnum.ELECTRICITY,
                            variant: "outline-default",
                            name: "heatingType"
                          },
                          on: { click: _vm.handleElectricity }
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("b-img", {
                                staticClass: "img-process",
                                attrs: {
                                  src: "/Content/PKS/images/sahkolammitys.png",
                                  alt: "Lämmitystapa sähkö"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "title",
                            domProps: {
                              textContent: _vm._s(
                                _vm.heatingTypeString(
                                  _vm.HeatingTypeEnum.ELECTRICITY
                                )
                              )
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "new-contract-value",
                              rawName: "v-new-contract-value"
                            }
                          ],
                          staticClass: "btn-profile",
                          class: {
                            active:
                              _vm.heatingType ==
                              _vm.HeatingTypeEnum.DISTRICTHEATING
                          },
                          attrs: {
                            disabled: _vm.loadingIndicator,
                            value: _vm.HeatingTypeEnum.DISTRICTHEATING,
                            variant: "outline-default",
                            name: "heatingType"
                          },
                          on: { click: _vm.handleDH }
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("b-img", {
                                staticClass: "img-process",
                                attrs: {
                                  src: "/Content/PKS/images/kaukolampo.png",
                                  alt: "Lämmitystapa kaukolämpö"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "title",
                            domProps: {
                              textContent: _vm._s(
                                _vm.heatingTypeString(
                                  _vm.HeatingTypeEnum.DISTRICTHEATING
                                )
                              )
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "new-contract-value",
                              rawName: "v-new-contract-value"
                            }
                          ],
                          staticClass: "btn-profile",
                          class: {
                            active:
                              _vm.heatingType == _vm.HeatingTypeEnum.GEOTHERMAL
                          },
                          attrs: {
                            disabled: _vm.loadingIndicator,
                            value: _vm.HeatingTypeEnum.GEOTHERMAL,
                            variant: "outline-default",
                            name: "heatingType"
                          },
                          on: { click: _vm.handleML }
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("b-img", {
                                staticClass: "img-process",
                                attrs: {
                                  src: "/Content/PKS/images/maalampo.png",
                                  alt: "Lämmitystapa maalämpö"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "title",
                            domProps: {
                              textContent: _vm._s(
                                _vm.heatingTypeString(
                                  _vm.HeatingTypeEnum.GEOTHERMAL
                                )
                              )
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "new-contract-value",
                              rawName: "v-new-contract-value"
                            }
                          ],
                          staticClass: "btn-profile",
                          class: {
                            active: _vm.heatingType == _vm.HeatingTypeEnum.OIL
                          },
                          attrs: {
                            disabled: _vm.loadingIndicator,
                            value: _vm.HeatingTypeEnum.OIL,
                            variant: "outline-default",
                            name: "heatingType"
                          },
                          on: { click: _vm.handleOIL }
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("b-img", {
                                staticClass: "img-process",
                                attrs: {
                                  src: "/Content/PKS/images/oljylammitys.png",
                                  alt: "Lämmitystapa öljy"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "title",
                            domProps: {
                              textContent: _vm._s(
                                _vm.heatingTypeString(_vm.HeatingTypeEnum.OIL)
                              )
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "new-contract-value",
                              rawName: "v-new-contract-value"
                            }
                          ],
                          staticClass: "btn-profile",
                          class: {
                            active: _vm.heatingType == _vm.HeatingTypeEnum.OTHER
                          },
                          attrs: {
                            disabled: _vm.loadingIndicator,
                            value: _vm.HeatingTypeEnum.OTHER,
                            variant: "outline-default",
                            name: "heatingType"
                          },
                          on: { click: _vm.handleOTHER }
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("b-img", {
                                staticClass: "img-process",
                                attrs: {
                                  src:
                                    "/Content/PKS/images/lammitystavat_muu.png",
                                  alt: "Muu lämmitystapa"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "title",
                            domProps: {
                              textContent: _vm._s(
                                _vm.heatingTypeString(_vm.HeatingTypeEnum.OTHER)
                              )
                            }
                          })
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { attrs: { id: "tarification" } },
        [
          _c(
            "b-col",
            { attrs: { md: "6", lg: "4" } },
            [
              _c(
                "validated-form-group",
                {
                  attrs: {
                    "validation-id": "Tarification",
                    "validation-errors": _vm.validationErrors
                  }
                },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-0",
                      attrs: {
                        "label-cols-sm": "12",
                        "label-cols-md": "12",
                        "label-cols-lg": "12"
                      }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "font-weight-bold pt-0",
                          attrs: { for: "tarification_field" }
                        },
                        [_vm._v(_vm._s(_vm.$t("Mittaustapa")))]
                      ),
                      _vm._v(" "),
                      _vm.contract.CustomerType == _vm.CustomerTypeEnum.CONSUMER
                        ? _c("b-form-select", {
                            directives: [
                              {
                                name: "new-contract-value",
                                rawName: "v-new-contract-value"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              id: "tarification_field",
                              disabled: _vm.loadingIndicator,
                              "bootstrap-styling": true,
                              "aria-describedby": "tariff-help-block",
                              name: "tarification",
                              value: _vm.tarification,
                              options: _vm.tarifications
                            }
                          })
                        : _c("b-form-select", {
                            directives: [
                              {
                                name: "new-contract-value",
                                rawName: "v-new-contract-value"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              id: "tarification_field",
                              "bootstrap-styling": true,
                              "aria-describedby": "tariff-help-block",
                              name: "tarification",
                              value: _vm.tarification,
                              options: _vm.tarifications
                            }
                          }),
                      _vm._v(" "),
                      _c(
                        "b-form-text",
                        { attrs: { id: "tariff-help-block" } },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t(
                                  "Jos et tiedä kohteen mittaustapaa, valitse yleissähkö. Mittaustavan voi vaihtaa myöhemmin."
                                )
                              ) +
                              "\n                    "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "6", lg: "4" } },
            [
              _c(
                "validated-form-group",
                {
                  attrs: {
                    "validation-id": "HouseArea",
                    "validation-errors": _vm.validationErrors
                  }
                },
                [
                  _c("b-form-group", {
                    staticClass: "mb-0",
                    attrs: {
                      "label-cols-sm": "12",
                      "label-cols-md": "12",
                      "label-cols-lg": "12"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "font-weight-bold pt-0",
                      attrs: { for: "housearea_field" }
                    },
                    [_vm._v(_vm._s(_vm.$t("Kohteen pinta-ala")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-input-group",
                    { attrs: { append: "m²" } },
                    [
                      _c("b-form-select", {
                        directives: [
                          {
                            name: "new-contract-value",
                            rawName: "v-new-contract-value"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          id: "housearea_field",
                          name: "area",
                          value: _vm.houseArea,
                          options: _vm.houseAreas
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "6", lg: "4" } },
            [
              _c(
                "validated-form-group",
                {
                  attrs: {
                    "validation-id": "energy1",
                    "validation-errors": _vm.validationErrors
                  }
                },
                [
                  _vm.tarification == 0 || _vm.tarification == 1
                    ? _c(
                        "div",
                        [
                          _c("b-form-group", {
                            staticClass: "mb-0",
                            attrs: {
                              "label-cols-sm": "12",
                              "label-cols-md": "12",
                              "label-cols-lg": "12"
                            }
                          }),
                          _c(
                            "label",
                            {
                              staticClass: "font-weight-bold pt-0",
                              attrs: { for: "energy1" }
                            },
                            [_vm._v(_vm._s(_vm.$t("Vuosikulutus (arvio)")))]
                          )
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-0",
                              attrs: {
                                "label-cols-sm": "12",
                                "label-cols-md": "12",
                                "label-cols-lg": "12"
                              }
                            },
                            [
                              _vm.tarification == 2
                                ? _c(
                                    "label",
                                    {
                                      staticClass: "font-weight-bold pt-0",
                                      attrs: { for: "energy1" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("Vuosikulutus (arvio) päivä")
                                        )
                                      )
                                    ]
                                  )
                                : _c(
                                    "label",
                                    {
                                      staticClass: "font-weight-bold pt-0",
                                      attrs: { for: "energy1" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "Vuosikulutus (arvio) talviarkipäivä"
                                          )
                                        )
                                      )
                                    ]
                                  )
                            ]
                          )
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _c(
                    "b-input-group",
                    { attrs: { append: "kWh" } },
                    [
                      _c("b-form-input", {
                        directives: [
                          {
                            name: "new-contract-value",
                            rawName: "v-new-contract-value"
                          }
                        ],
                        attrs: {
                          type: "text",
                          name: "energy1",
                          id: "energy1",
                          value: _vm.energy1
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-form-input", {
                    directives: [
                      {
                        name: "new-contract-value",
                        rawName: "v-new-contract-value"
                      }
                    ],
                    attrs: {
                      type: "range",
                      min: "500",
                      max: "40000",
                      step: "100",
                      value: _vm.energy1,
                      name: "energy1",
                      id: "energy3",
                      "aria-label": "Vuosikulutusarvio"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.showEnergy2Consumption
            ? _c(
                "b-col",
                { attrs: { md: "5" } },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-0",
                      attrs: {
                        "label-cols-sm": "12",
                        "label-cols-md": "12",
                        "label-cols-lg": "12"
                      }
                    },
                    [
                      _vm.tarification == 2
                        ? _c(
                            "label",
                            {
                              staticClass: "font-weight-bold pt-0",
                              attrs: { for: "energy2" }
                            },
                            [_vm._v(_vm._s(_vm.$t("Vuosikulutus (arvio) yö")))]
                          )
                        : _c(
                            "label",
                            {
                              staticClass: "font-weight-bold pt-0",
                              attrs: { for: "energy2" }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("Vuosikulutus (arvio) muu aika"))
                              )
                            ]
                          )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-input-group",
                    { attrs: { append: "kWh" } },
                    [
                      _c("b-form-input", {
                        directives: [
                          {
                            name: "new-contract-value",
                            rawName: "v-new-contract-value"
                          }
                        ],
                        attrs: {
                          type: "text",
                          name: "energy2",
                          id: "energy2",
                          value: _vm.energy2
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-form-input", {
                    directives: [
                      {
                        name: "new-contract-value",
                        rawName: "v-new-contract-value"
                      }
                    ],
                    attrs: {
                      type: "range",
                      min: "500",
                      max: "40000",
                      step: "100",
                      value: _vm.energy2,
                      name: "energy2",
                      id: "energy4",
                      "aria-label": "Vuosikulutusarvio"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }